const ALGOLIA_FILTERS = {
  castNumOptions: "castNumOptions",
  templateGroupTypeName: "templateGroupTypeName",
};

Object.freeze(ALGOLIA_FILTERS);

export { ALGOLIA_FILTERS };
